import { render } from "./chart-locked.vue?vue&type=template&id=51a28941&scoped=true&ts=true"
import script from "./chart-locked.vue?vue&type=script&lang=ts"
export * from "./chart-locked.vue?vue&type=script&lang=ts"

import "./chart-locked.vue?vue&type=style&index=0&id=51a28941&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a28941"]])

export default __exports__